import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {array} payload.cartItems - The items in cart.
 */
export const onTrackCheckout = async (payload) => {
  const { cartItems } = payload;
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  const gaService = injector.get('gaService');
  const Analytics = injector.get('Analytics');

  const isAllRedeemGift = cartItems.every(
    (item) => item.type === 'redeem_gift',
  );

  trackerService.userAction('Checkout', null, {
    scope: 'one_page_store',
  });

  if (Analytics.configuration.enhancedEcommerce && !isAllRedeemGift) {
    gaService.setUserId();
    Analytics.trackCheckout(3, 'Filled Form');
    Analytics.trackEvent('UX', 'place_order', 'Place Order', undefined, true);
  }
};
